// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__2wI88","footer":"ModalFilter_footer__25-Ca"};